export default function PhotoEssays({ items = [] }) {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  // Tight 6-frame mosaic
  const spans = [
    "md:col-span-8 md:row-span-2 aspect-[16/11]",
    "md:col-span-4 aspect-[4/5]",
    "md:col-span-5 aspect-[5/4]",
    "md:col-span-7 aspect-[16/9]",
    "md:col-span-6 aspect-[16/9]",
    "md:col-span-6 aspect-[16/9]",
  ];

  return (
    <section
      id="photos"
      data-testid="photos-section"
      className="relative bg-[#F7F7F5] text-[#1A1A1A] py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-px bg-[#1A1A1A]" />
            <span className="font-mono-overline">05 — From the camera roll</span>
          </div>
          <h2 className="font-serif-display text-3xl md:text-5xl leading-[1.05] max-w-3xl">
            Frames from <em className="text-[#A68661]">the field</em>.
          </h2>
          <p className="text-[#1A1A1A]/60 text-sm md:text-base mt-3 max-w-xl">
            Behind every story — portraits, landscapes, and frames that didn't make the cut.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
          {items.map((p, idx) => (
            <figure
              key={p.id}
              data-testid={`photo-${p.id}`}
              className={`relative col-span-1 ${spans[idx] || "md:col-span-6 aspect-[4/3]"} img-zoom bg-black/5 group`}
            >
              <img
                src={p.image_url.startsWith("https://i.cbc.ca/") ? `${BACKEND_URL}/api/image-proxy?url=${encodeURIComponent(p.image_url)}` : p.image_url}
                alt={p.caption}
                loading="lazy"
              />
              <figcaption className="absolute bottom-0 left-0 right-0 p-4 md:p-6 bg-gradient-to-t from-black/70 via-black/30 to-transparent text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="font-mono-overline text-[#C4A27A] mb-1">{p.location}</div>
                <div className="font-serif-display italic text-lg md:text-xl">{p.caption}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
